// 格式化日期 YYYY-MM-DD
export function formatDateTime (inputTime) {
    // debugger
    let date = new Date(inputTime)
    // 年 getFullYear()：四位数字返回年份
    let y = date.getFullYear()
    // 月 getMonth()：0 ~ 11
    let m = date.getMonth() + 1
    // 日 getDate()：(1 ~ 31)
    let d = date.getDate()
    let time = y + '-' + addZero(m) + '-' + addZero(d) 
    return time
  };

// 格式化日期 YYYY-MM-DD HH:MM:SS
export function formatTime (inputTime) {
  let date = new Date(inputTime)
  // 年 getFullYear()：四位数字返回年份
  let year = date.getFullYear() // getFullYear()代替getYear()
  // 月 getMonth()：0 ~ 11
  let month = date.getMonth() + 1
  // 日 getDate()：(1 ~ 31)
  let day = date.getDate()
  // 时 getHours()：(0 ~ 23)
  let hour = date.getHours()
  // 分 getMinutes()： (0 ~ 59)
  let minute = date.getMinutes()
  // 秒 getSeconds()：(0 ~ 59)
  let second = date.getSeconds()
  let time = year + '-' + addZero(month) + '-' + addZero(day) + ' ' + addZero(hour) + ':' + addZero(minute) + ':' + addZero(second)
  return time
};

  // 获取当前时间
export function getNowTime () {
    let date = new Date()
    // 年 getFullYear()：四位数字返回年份
    let year = date.getFullYear() // getFullYear()代替getYear()
    // 月 getMonth()：0 ~ 11
    let month = date.getMonth() + 1
    // 日 getDate()：(1 ~ 31)
    let day = date.getDate()
    // // 时 getHours()：(0 ~ 23)
    // let hour = date.getHours()
    // // 分 getMinutes()： (0 ~ 59)
    // let minute = date.getMinutes()
    // // 秒 getSeconds()：(0 ~ 59)
    // let second = date.getSeconds()
    let time = year + '-' + addZero(month) + '-' + addZero(day)
    return time
  }

// 格式化日期 YYYY-MM-DDTHH:MM:SS.SSSZ
export function formatBeginTime (inputTime) {
  let date = new Date(inputTime)
  // 年 getFullYear()：四位数字返回年份
  let year = date.getFullYear() // getFullYear()代替getYear()
  // 月 getMonth()：0 ~ 11
  let month = date.getMonth() + 1
  // 日 getDate()：(1 ~ 31)
  let day = date.getDate()
  let time = year + '-' + addZero(month) + '-' + addZero(day) + 'T' + '00' + ':' + '00' + ':' + '00.000'+'Z'
  return time
};
// 格式化日期 YYYY-MM-DDTHH:MM:SS.SSSZ
export function formatEndTime (inputTime) {
  let date = new Date(inputTime)
  // 年 getFullYear()：四位数字返回年份
  let year = date.getFullYear() // getFullYear()代替getYear()
  // 月 getMonth()：0 ~ 11
  let month = date.getMonth() + 1
  // 日 getDate()：(1 ~ 31)
  let day = date.getDate()
  let time = year + '-' + addZero(month) + '-' + addZero(day) + 'T' + '23' + ':' + '59' + ':' + '59.999'+'Z'
  return time
};
  
  // 小于10的拼接上0字符串
function addZero (s) {
    return s < 10 ? ('0' + s) : s
  }